import { useEffect, useState } from "react";

// Sem `children` é o "?" de sempre dos cards. Com `children` o gatilho é o conteúdo passado
// (ex.: o ícone do `AnnulmentIndicator`): vira um botão focável pelo teclado, que mostra o
// texto também no foco, repete o texto em `aria-label` e aceita clique. Só usa <span>: o
// indicador aparece dentro de <p> e de títulos, onde <div> é aninhamento inválido.
const Tooltip = ({ small, padding, message, style, children, onClick, ariaLabel, boxClassName }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => setShowTooltip(true);
  const handleMouseLeave = () => setShowTooltip(false);

  // Escape dispensa o tooltip (hover ou foco) enquanto ele está aberto.
  useEffect(() => {
    if (!showTooltip) return undefined;
    const onKey = (event) => { if (event.key === "Escape") setShowTooltip(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [showTooltip]);

  if (children !== undefined) {
    return (
      <span className="tooltip-container"
        style={style}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <span
          className="tooltip-trigger"
          role="button"
          tabIndex={0}
          aria-label={ariaLabel ?? message}
          onClick={onClick}
          onFocus={handleMouseEnter}
          onBlur={handleMouseLeave}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onClick?.(event);
            }
          }}
        >
          {children}
        </span>
        {(message && showTooltip) && (
          <span className={`tooltip-box${boxClassName ? ` ${boxClassName}` : ""}`} role="tooltip">{message}</span>
        )}
      </span>
    );
  }

  return (
    <div className="tooltip-container"
      style={style}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <div
        className="tooltip-trigger"
      >
        <p className="open-helper-button question">?</p>
      </div>
      {(message && showTooltip) && <div className="tooltip-box">{message}</div>}
    </div>
  );
};


export default Tooltip
